import React, { useEffect, useState } from 'react';
import { Container, Row, Col } from 'reactstrap';
import { MapBox, MapBoxFilter } from './';
import { Section } from '../Sections';

interface Pin {
  name: any;
  address: any;
  geopoint: {
    latitude: number;
    longitude: number;
  };
}
interface Props {
  data: {
    map_restaurants: Array<MapItem>;
    map_bars: Array<MapItem>;
    map_shops: Array<MapItem>;
    map_fitness: Array<MapItem>;
    map_grocery: Array<MapItem>;
    map_transportation: Array<MapItem>;
  };
}
interface MapItem {
  name: any;
  address: any;
  geopoint: {
    latitude: number;
    longitude: number;
  };
}

export const MapBoxSection: React.FunctionComponent<Props> = ({ data }) => {
  // initial selected filter
  const [activeFilter, setActiveFilter] = useState('restaurants');
  const [selectedPin, setSelectedPin] = useState<Pin>();

  const filterData = [
    {
      id: 'restaurants',
      title: 'Restaurants',
      data: data.map_restaurants,
    },
    {
      id: 'bars-nightlife',
      title: 'Bars & Nightlife',
      data: data.map_bars,
    },
    {
      id: 'shops-retail',
      title: 'Shops & Retail',
      data: data.map_shops,
    },
    {
      id: 'fitness-wellness',
      title: 'Fitness & Wellness',
      data: data.map_fitness,
    },
    {
      id: 'grocery',
      title: 'Grocery',
      data: data.map_grocery,
    },
    {
      id: 'transportation',
      title: 'Transportation',
      data: data.map_transportation,
    },
  ];

  return (
    <Section hasTop hasBottom={false}>
      <div className="mapbox-section">
        <Container fluid>
          {/* Using custom column for better alignment of filters & map */}
          <div className="mapbox-row">
            <MapBoxFilter
              data={filterData}
              activeFilter={activeFilter}
              setActiveFilter={setActiveFilter}
              setSelectedPin={setSelectedPin}
              selectedPin={selectedPin}
            />
            <MapBox
              data={filterData}
              activeFilter={activeFilter}
              setSelectedPin={setSelectedPin}
              selectedPin={selectedPin}
            />
          </div>
        </Container>
      </div>
    </Section>
  );
};
